import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Calendar from "./routes/Calendar";

import "../src/scss/custom.scss";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Calendar />,
    // children: [
    //   { path: "/contact", element: <Contact /> },
    //   { path: "/calendar", element: <Calendar /> },
    // ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
